export default __webpack_public_path__ + "static/media/WB_FutureSnowGlobe.aace4e69.gif";